import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CatalogModule } from '@app/shared/components/catalog/catalog.module';

import { CatalogPageRoutingModule } from './catalog-page-routing.module';
import { CatalogPageComponent } from './catalog-page.component';
import { BreadcrumbModule } from '@app/shared/components/breadcrumb/breadcrumb.module';
import { CatalogPageResolver } from './catalog-page-resolver.service';
import { reducers } from '@app/+catalog/store/reducers';
import { StoreModule } from '@ngrx/store';
import { CatalogLinksResolver } from '@app/+catalog/catalog-links-resolver.service';
import { CatalogCampaignResolver } from './catalog-campaign-resolver.service';
import { RefModule } from '@app/shared/components/ref/ref.module';

@NgModule({
  imports: [
    CommonModule,
    CatalogPageRoutingModule,
    CatalogModule,
    BreadcrumbModule,
    StoreModule.forFeature('catalogPage', reducers),
    RefModule
  ],
  declarations: [CatalogPageComponent],
  providers: [CatalogPageResolver, CatalogLinksResolver, CatalogCampaignResolver]
})
export class CatalogPageModule {}
